<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4" class="d-flex chi" v-for="n in 34" :key="n">
        <v-img
          :src="'/by_use/img/portadas/portada-web-' + n + '.jpg'"
          min-height="120"
          @click="mdd.por = n"
        >
          <v-row class="fill-height ma-0" align="end" justify="start">
            <v-btn icon>
              <v-icon
                small
                color="white"
                v-text="
                  mdd.por === n ? 'check_circle' : 'radio_button_unchecked'
                "
              ></v-icon>
            </v-btn>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "user-libro-portadas",
  props: ["mdd"]
};
</script>
